import React from "react";

const practiceOfGeneralInsuranceSyllabus = [
    {
        chapter: 1,
        title: "Introduction to General Insurance",
        subTopics: [
            "Origin of Insurance",
            "Indian Insurance Market",
            "Foreign Insurance Market",
            "Different Roles within Insurance Industry",
            "Non-Life Insurance",
            "Understanding Claim Process for Non-Life Insurance",
            "Understanding Reinsurance Terminologies",
        ],
        hours: 2,
    },
    {
        chapter: 2,
        title: "Policy Documents and Forms",
        subTopics: [
            "Insurance Contract & Parties to Contract",
            "Insurance Policy – A Contract Document",
            "Understand Policy Components",
            "Interpret a Policy Document",
            "Insurance Proposal Form and Certificate",
        ],
        hours: 2,
    },
    {
        chapter: 3,
        title: "General Insurance Products – I",
        subTopics: [
            "Classification of General Insurance Business",
            "Fire Insurance",
            "Marine Cargo Insurance",
            "Marine Hull Insurance",
        ],
        hours: 3,
    },
    {
        chapter: 4,
        title: "General Insurance Products – II",
        subTopics: [
            "Motor Insurance",
            "Motor Insurance Underwriting & Rating",
            "Type of Motor Claims",
            "Motor Claim Procedure",
            "Liability Insurance – Types of Policies",
            "Personal Accident & Health Insurance Policies",
        ],
        hours: 4,
    },
    {
        chapter: 5,
        title: "General Insurance Products – III",
        subTopics: [
            "Engineering Insurance",
            "Miscellaneous Insurance",
            "Aviation Insurance",
            "Oil & Energy Risks Insurance",
            "Cyber Risks",
        ],
        hours: 3,
    },
    {
        chapter: 6,
        title: "Underwriting",
        subTopics: [
            "Concept of Underwriting",
            "Underwriting Process",
            "Risk Sharing",
            "Reinsurance & Types of Reinsurance",
            "Risk Management",
        ],
        hours: 3,
    },
    {
        chapter: 7,
        title: "Rating & Premium",
        subTopics: [
            "Mechanism of Premium Pricing",
            "Concept of Soft Market & Hard Market",
        ],
        hours: 2,
    },
    {
        chapter: 8,
        title: "Claims",
        subTopics: [
            "Basic Concept of Claim in Insurance Policy",
            "Claim Process",
            "Process of Claim Management",
            "Types of Claims & Claim Payments",
        ],
        hours: 3,
    },
    {
        chapter: 9,
        title: "Insurance Reserves & Accounting",
        subTopics: [
            "Various Reserves by Insurance Company",
            "Premium Investment Strategies by Insurance Companies",
            "Insurance Accounting",
        ],
        hours: 3,
    },
];


export const PracticeofGeneralInsuranceTable = () => {
    const totalHours = practiceOfGeneralInsuranceSyllabus.reduce((sum, item) => sum + item.hours, 0);

    return (
        <div className="container my-3 px-0"
            style={{
                maxHeight: 'fit-content'
            }}
        >
            <h5 className="text-center">IC- 11- Practice of General Insurance</h5>
            <div className="table-responsive"
                style={{ height: '70vh' }}
            >
                <table className="table table-bordered table-striped align-middle">
                    <thead className="table-success text-center">
                        <tr>
                            <th className="bgblue">Chapter</th>
                            <th className="bgblue">Title</th>
                            <th className="bgblue">Sub-Topics</th>
                            <th className="bgblue">Training Hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        {practiceOfGeneralInsuranceSyllabus.map((item, index) => (
                            <tr key={index}>
                                <td className="text-center fw-bold">{item.chapter}</td>
                                <td>{item.title}</td>
                                <td>
                                    <ul className="mb-0 ps-3" style={{ listStylePosition: "inside" }}>
                                        {item.subTopics.map((topic, i) => (
                                            <li key={i}>{topic}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="text-center fw-semibold">{item.hours}</td>
                            </tr>
                        ))}
                        <tr className="table-secondary fw-bold">
                            <td colSpan={3} className="text-end">Total Training Hours =</td>
                            <td className="text-center">{totalHours}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
